import { Divider, Flex, HStack, Icon, Text, useColorModeValue as colorValue } from "@chakra-ui/react"
import { useEffect, useRef, useState } from "react"
import { getOwnerActiveContract } from "../../classes/Contract"
import { useUserContext } from "../../context/userContext"
import { BlockContainer } from "../shared/Block"
import { BiHomeHeart } from "react-icons/bi";
import { LabelInfo, TextDateFormat } from "../shared"
// import { errorHandle } from "../../api/api"
import { toastErrDesc, toastVal } from '../../utils/toastUtils'
import { useToast } from '@chakra-ui/react'

const ResidentCurrentContract = () => {
    const toast = useToast()
    const loadData = useRef(null)
    const { userData } = useUserContext()
    const [currentContract, setCurrentContract] = useState(null)

    loadData.current = async () => {
        try {
            const contract = await getOwnerActiveContract(userData.token)
            if (contract?.length > 0) {
                setCurrentContract(contract[0])
                //console.log(contract[0])
            }
        } catch (error) {
            // console.log('error')
            // console.log(errorHandle(err))
            toast(toastVal({
                title: "การดึงข้อมูล ไม่สำเร็จ",
                description: toastErrDesc(error),
                status: "error",
            }))
        }
    }

    useEffect(() => {
        loadData.current()
    }, [])

    return (
        <BlockContainer bgColor={colorValue("blue.50", "blue.600")}>
            <Flex>
                <Icon as={BiHomeHeart} boxSize={100} color={colorValue("blue.600", "blue.50")} />
                <Divider orientation='vertical' mx={30} />
                {currentContract ?
                    <Flex direction="column" width="full">
                        <HStack>
                            <LabelInfo title="ชื่อผู้เข้าพัก">{`${currentContract.first_name} ${currentContract.last_name}`}</LabelInfo>
                            <LabelInfo title="ตำแหน่ง">{currentContract.position_name}</LabelInfo>
                            <LabelInfo title="หน่วยงาน">{currentContract.office_name}</LabelInfo>
                        </HStack>
                        <HStack>
                            <LabelInfo title="สัญญาเลขที่">{currentContract.contract_no}</LabelInfo>
                            <LabelInfo title="วันที่ทำสัญญา"><TextDateFormat value={currentContract.contract_date} datetime={false} /></LabelInfo>
                            <LabelInfo title="อายุสัญญา">{currentContract.contract_age} ปี</LabelInfo>
                        </HStack>
                        <LabelInfo title="ตั้งแต่วันที่">
                            <HStack>
                                <TextDateFormat value={currentContract.contract_start_date} datetime={false} />
                                <Text>ถึง</Text>
                                <TextDateFormat value={currentContract.contract_end_date} datetime={false} />
                            </HStack>
                        </LabelInfo>
                        <HStack>
                            <LabelInfo title="อาคาร">{currentContract.residence_name}</LabelInfo>
                            <LabelInfo title="เข้าพักห้องที่">{currentContract.room_no}</LabelInfo>
                        </HStack>
                    </Flex>
                    :
                    "..."
                }
            </Flex>
        </BlockContainer>
    )
}

export default ResidentCurrentContract